// @flow
import type {Node} from 'react';
import {Box, Typography} from '@wellstone-solutions/web';
import {Theme} from '@wellstone-solutions/common';
import peaceHand from 'assets/images/peace-hand.svg';

type PropsType = {
  title?: string,
};

export const UnassignedEmptyState = ({title}: PropsType = {}): Node => {
  return (
    <Box sx={styles.container}>
      <Typography sx={styles.title}>
        {title ?? <>Nobody&rsquo;s here! You&rsquo;re all caught up!</>}
      </Typography>
      <img src={peaceHand} alt="" height={132} />
    </Box>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    pt: 0,
    pb: 8,
    px: 2,
    gap: 2,
  },
  title: {
    fontSize: '28px',
    lineHeight: '1.33',
    fontWeight: 700,
    letterSpacing: '-0.1px',
    color: Theme.colorPalette.darkest,
    textAlign: 'center',
  },
};
